import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const DetailSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('mb-4 overflow-hidden', className);

	// Render
	return (
		<Card className={rootClassName}>
			<CardHeader className='aspect-[4/2] overflow-hidden'>
				<Skeleton className='leading-[inherit]' />
			</CardHeader>
			<CardContent className='gap-2'>
				<Skeleton className='-mt-12 mb-4 aspect-square w-20 rounded-control border' />
				<CardTitle>
					<Skeleton className='w-3/4' />
				</CardTitle>
				<CardDescription>
					<Skeleton className='w-1/2' />
				</CardDescription>
				<CardDescription>
					<Skeleton className='w-1/4' />
				</CardDescription>
			</CardContent>
		</Card>
	);
};

export { DetailSkeleton };

// Docs:
// https://github.com/dvtng/react-loading-s#readme
